import { Badge } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

import useAutoRefresh from '../hooks/useAutoRefresh';

import progressFormatter from './ProgressFormatter';
import { COLORS, STATUS_LABEL } from './utils';

export default function StatusFormatter({ info }) {
  const { row, value } = getInfo(info)
  const hasFile = row.meta?.file?.filekey
  const cell = value === 'error' && hasFile ? 'finished' : value
  const color = COLORS[cell]
  const label = STATUS_LABEL[cell] || cell
  const processing = ['processing', 'finishing'].includes(cell)

  useAutoRefresh(row.id, cell)

  return <Badge color={color} variant='outline'>
    {label} {processing ? <>[{progressFormatter({ value: row.meta?.stepProgress })}]</> : ''}
  </Badge>
}

